import { render } from "./IncomeCertificate.vue?vue&type=template&id=3483e9d6"
import script from "./IncomeCertificate.vue?vue&type=script&lang=js"
export * from "./IncomeCertificate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__